import { AuditLogsItemRequestDto, ILogsResponseDto, AuditLogsItemDto } from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'
import { isNil } from 'lodash'

export const fetchAuditLogs = async (
  {
    token,
    id,
    client,
    ...params
  }: { id: string; client: 'user' | 'company' } & AuditLogsItemRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ILogsResponseDto<AuditLogsItemDto>> => {
  const response = await axios.get<ILogsResponseDto<AuditLogsItemDto>>(
    `${process.env.REACT_APP_SERVER_URL}/crm/${client}/audit-logs/${id}`,
    {
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const fetchLogTypes = async (
  { token, id, client }: { id: string; client: 'user' | 'company' } & { token: string },
  options: AxiosRequestConfig = {},
): Promise<Array<string>> => {
  const response = await axios.get<Array<string>>(
    `${process.env.REACT_APP_SERVER_URL}/crm/log-types-by-${client}/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}
